import ReportVisitor from "./ReportVisitor.js";

/**
 * This visitor is responsible for returning the CSS classes
 * of report items.
 */
export default class CssClassNameVisitor extends ReportVisitor {
	visitAbstractItem() {
		return "";
	}

	visitAccountRow() {
		return "account";
	}

	visitGeneratedAccountGroupRow(row) {
		if (row.isExcluded()) {
			return "excluded no-sort";
		}
		return "report-group no-sort";
	}

	visitGeneratedAccountRow() {
		return "account no-sort";
	}

	visitFormulaRow() {
		return "formula";
	}

	visitGroupRow() {
		return "report-group";
	}

	visitKeyFigureRow() {
		return "key-figure";
	}

	visitTextRow() {
		return "text-row";
	}

	visitSpacerRow(row) {
		const short = row.isShort();
		const long = !short;

		return [
			"spacer",
			{ "horizontal-line": row.isHorizontalLine(), short, long },
		];
	}

	visitRepeatingRow() {
		return "repeating";
	}

	visitSeparatorColumn(column) {
		return `separator ${column._narrow ? "narrow" : "wide"}`;
	}
}
